export default "__VITE_ASSET__DhHYmlKZ__"